import React from 'react'
import { FaArrowRightLong } from "react-icons/fa6";

const FooterTop = () => {
  return (
    <div className='top-footer'>
          <p>So what are you waiting for?</p>
          <h2>Start Your Prime Journey Today</h2>
          <button className='glare-effect'>Enroll Now <FaArrowRightLong/></button>
    </div>
  )
}

export default FooterTop;
